/* eslint-disable prettier/prettier */
import React from 'react';
function FamilyFarmDay() {
  /*<div className="ffdRow">
        <div className="eventCol">
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "LFCF_poster2a.png"}
            alt="Johnny Cash event"
          ></img>
        </div>
      </div>*/
  return (
    <div className="">
      <div style={{display:'block',
          marginBottom: '30px',
          height: '600px',
          overflow: 'scroll',
          marginTop: '70px',
          width: '400px'
        }}
      >
        <img
          style={{
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '0px',
            width: '400px',
          }}
          src={process.env.PUBLIC_URL + '/events/' + 'countryFest2026.png'}
          alt="Country Fest"
        ></img>
        <img
          style={{
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '0px',
            width: '400px',
          }}
          src={process.env.PUBLIC_URL + '/events/' + 'cfestdetails.jpeg'}
        ></img>
      </div>
    </div>
  );
}

export default FamilyFarmDay;
